/* eslint-disable */
import { TableColumn } from 'react-data-table-component';
import { DefaultTable } from 'src/components/default-table';
import { CommonCurrencyInput, CommonInput, RegularButton } from 'pg-ui-library';
import { IBenefit, IDependent } from 'src/interfaces';
import {
  BeneficiariesListContainer,
  BeneficiariesListFooter,
  BeneficiariesListRightBottom,
  CreateBeneficiariesPercentage,
  CreateBeneficiariesPercentageContainer,
  CreateBeneficiariesPercentageInputs,
  CreateBeneficiariesPercentageInputsContainer,
} from './styles';
import { useEffect, useState } from 'react';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useTranslation } from 'react-i18next';
import closeSvg from 'src/assets/close.svg';
import ReactModal from 'react-modal';
import { CloseIcon } from '../beneficiaries-modal/styles';
import { RegularText } from 'src/modules/tax-forms/styles';
import { BeneficiariesForm } from '../beneficiaries-settings-form';
import { useQuery } from '@tanstack/react-query';
import PersonalInfoService from 'src/services/personal-info.service';

const columns: TableColumn<IDependent>[] = [
  {
    name: 'Name',
    selector: (row: IDependent) => row.firstName as unknown as '',
  },
  {
    name: 'Relationship',
    selector: (row: IDependent) => row.relationship as unknown as '',
  },
  {
    name: 'SSN',
    selector: (row: IDependent) => row.ssn as unknown as '',
  },
  {
    name: 'Home Phone',
    selector: (row: IDependent) => row.homePhone as unknown as '',
  },
  {
    name: 'Work Phone',
    selector: (row: IDependent) => row.workPhone as unknown as '',
  },
  {
    name: 'Email',
    selector: (row: IDependent) => row.email as unknown as '',
  },
];

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 16px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '5px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  pagination: {
    style: {
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

export const BeneficiariePercentage: React.FC<{
  isOpen?: boolean;
  setIsOpen?: any;
  selectedBeneficiaries: IDependent[];
  onSubmit: any;
}> = ({ isOpen, setIsOpen, selectedBeneficiaries, onSubmit }) => {
  const [selectedBeneficiariesPercentage, setSelectedBeneficiariesPercentage] = useState<IDependent[]>([]);
  useEffect(() => {
    setSelectedBeneficiariesPercentage(selectedBeneficiaries as unknown as []);
  }, [isOpen]);
  return (
    <>
      <ReactModal
        isOpen={isOpen as unknown as false}
        ariaHideApp={false}
        style={{
          overlay: {
            margin: 'auto',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
          content: {
            borderRadius: '30px',
            margin: 'auto',
            width: '700px',
            height: '380px',
            display: 'flex',
            flexDirection: 'column',
            padding: '38px',
          },
        }}
      >
        <CreateBeneficiariesPercentageContainer>
          <BeneficiariesForm
            beneficiaries={selectedBeneficiaries}
            onSubmit={onSubmit}
            onRequestBack={() => {
              setIsOpen(false);
            }}
          />
        </CreateBeneficiariesPercentageContainer>
      </ReactModal>
    </>
  );
};

export const BeneficiariesList: React.FC<{
  benefit?: IBenefit;
  createBeneficiary: boolean;
  handleBeneficiariesModal?: any;
  onSubmit: (beneficiaries: IDependent[]) => void;
  onRequestNewBeneficiarie?: () => void;
}> = ({ benefit, createBeneficiary, handleBeneficiariesModal, onSubmit, onRequestNewBeneficiarie }) => {
  const { t } = useTranslation();
  const { isFetching, data, refetch } = useQuery(['/personal-informations'], async () => {
    const result = await PersonalInfoService.getPersonalInformation();
    return result;
  });

  const [isOpen, setIsOpen] = useState(false);

  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState<IDependent[]>([]);

  const allContactslist = data?.data.dependents.concat(data?.data.emergencyContacts);

  const removeDuplicateDependentsById = (arr: IDependent[]): IDependent[] => {
    const seen: { [key: string]: boolean } = {};
    return arr?.filter(obj => {
      if (seen[obj.id as string]) {
        return false;
      }
      seen[obj.id as string] = true;
      return true;
    });
  };

  const list = removeDuplicateDependentsById(allContactslist);

  const handleSelection = ({ selectedRows }: { selectedRows: IDependent[] }) => {
    setSelectedBeneficiaries(selectedRows);
  };

  useEffect(() => {
    refetch();
  }, [createBeneficiary]);

  return (
    <>
      <BeneficiariesListContainer>
        <BeneficiariePercentage
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          selectedBeneficiaries={selectedBeneficiaries}
          onSubmit={onSubmit}
        />
        <DefaultTable
          columns={columns}
          data={list || []}
          customStyles={customStyles}
          selectableRows
          onSelectedRowsChange={handleSelection}
        />
      </BeneficiariesListContainer>
      <BeneficiariesListFooter>
        <RegularButton onClick={() => handleBeneficiariesModal()}>{t('global.button.back')}</RegularButton>
        <BeneficiariesListRightBottom>
          {onRequestNewBeneficiarie && (
            <RegularButton onClick={onRequestNewBeneficiarie}>{t('benefits.beneficiaries.title')}</RegularButton>
          )}
          <RegularButton disabled={!selectedBeneficiaries.length} onClick={() => setIsOpen(true)}>
            {t('global.form.continue')}
          </RegularButton>
        </BeneficiariesListRightBottom>
      </BeneficiariesListFooter>
    </>
  );
};
